import { render, staticRenderFns } from "./event-details.vue?vue&type=template&id=06d48de3&scoped=true"
import script from "./event-details.vue?vue&type=script&lang=js"
export * from "./event-details.vue?vue&type=script&lang=js"
import style0 from "./event-details.vue?vue&type=style&index=0&id=06d48de3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d48de3",
  null
  
)

export default component.exports